import axios from "axios"

const url = "/distributor/admin/api/v1/inventory/loose-items"
export function getAllDealerLooseItemListing (parameters) {
  return new Promise((resolve, reject) => {
    axios.post(url, {
      length: parameters.length,
      start: parameters.start,
      dealer: parameters.dealer,
      filter: {
        search: parameters.filter.search,
      }
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};